





























import mixins from 'vue-typed-mixins';
import { DataTableHeader } from 'vuetify';
import ProviderUtils, { ServiceProviderType } from '../../utils/ProviderUtils';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<ServiceProviderType>[] {
      return [{ text: this.$i18n.tc('model.common.name', 2), value: 'name' }];
    },
  },
  data(): {
    types?: ServiceProviderType[];
    search: string;
  } {
    return {
      types: undefined,
      search: '',
    };
  },
  async mounted() {
    try {
      this.types = await ProviderUtils.api.type.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'provider-type-create' });
    },
    async edit(type: ServiceProviderType) {
      await this.$router.push({
        name: 'provider-type-edit',
        params: { id: `${type.id}` },
      });
    },
    async remove(type: ServiceProviderType) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [this.$translate(type.name)])
          .toString(),
        async () => {
          if (type.id && this.types) {
            this.$alert.hide('remove');
            await ProviderUtils.api.type.remove(type.id);
            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [type.name],
              }),
            });
            const index = this.types.findIndex((val) => val.id === type.id);
            if (index >= 0) {
              this.types.splice(index, 1);
            }
          }
        }
      );
    },
  },
});
